/**
 * @generated SignedSource<<cf93c728e444549a25aa5c315315a38e>>
 * @relayHash 66b732c66a3bd46b7ee2d214ee98303c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 66b732c66a3bd46b7ee2d214ee98303c

import { ConcreteRequest } from 'relay-runtime';
export type PaymentMethodType = "CREDIT_CARD" | "SEPA_DEBIT" | "US_BANK_ACCOUNT" | "%future added value";
export type GenerateStripeSetupIntentClientSecretInput = {
  paymentMethodType: PaymentMethodType;
  returnUrl?: string | null;
};
export type useCreateBillingMethodClientSecretMutation$variables = {
  input: GenerateStripeSetupIntentClientSecretInput;
};
export type useCreateBillingMethodClientSecretMutation$data = {
  readonly generateStripeSetupIntentClientSecret: {
    readonly clientSecret: string | null;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }> | null;
  };
};
export type useCreateBillingMethodClientSecretMutation = {
  response: useCreateBillingMethodClientSecretMutation$data;
  variables: useCreateBillingMethodClientSecretMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientSecret",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateBillingMethodClientSecretMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GenerateStripeSetupIntentClientSecretPayload",
        "kind": "LinkedField",
        "name": "generateStripeSetupIntentClientSecret",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateBillingMethodClientSecretMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GenerateStripeSetupIntentClientSecretPayload",
        "kind": "LinkedField",
        "name": "generateStripeSetupIntentClientSecret",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "66b732c66a3bd46b7ee2d214ee98303c",
    "metadata": {},
    "name": "useCreateBillingMethodClientSecretMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "41e31dc215053d3c0a70ef5fa4af4535";

export default node;
